import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { OverlayPlacementName } from '../../../../../types';
import { SMALL_SELECTABLES_ITEM_CONTENT_WIDTH, SMALL_SELECTABLES_ITEM_CONTENT_HEIGHT } from '../../../common/selectable/containers/SmallSelectabes';

export const PLACEMENT_IMAGE_WIDTH = SMALL_SELECTABLES_ITEM_CONTENT_WIDTH;
export const PLACEMENT_IMAGE_HEIGHT = SMALL_SELECTABLES_ITEM_CONTENT_HEIGHT;

const Root = styled.div`
  position: relative;
  width: ${PLACEMENT_IMAGE_WIDTH}px;
  height: ${PLACEMENT_IMAGE_HEIGHT}px;
`;

const Square = styled.div<{ placement: OverlayPlacementName }>`
  position: absolute;
  width: ${globalTheme.spacing.sm};
  height: ${globalTheme.spacing.sm};
  border: solid 1px ${globalTheme.palette.contrastLow};
  border-radius: ${globalTheme.radius.md};

  ${(props) => props.placement === 'top_left' && css`
    top: ${globalTheme.spacing.xxs};
    left: ${globalTheme.spacing.xxs};
  `};
  ${(props) => props.placement === 'top_right' && css`
    top: ${globalTheme.spacing.xxs};
    right: ${globalTheme.spacing.xxs};
  `};
  ${(props) => props.placement === 'bottom_left' && css`
    bottom: ${globalTheme.spacing.xxs};
    left: ${globalTheme.spacing.xxs};
  `};
  ${(props) => props.placement === 'bottom_right' && css`
    bottom: ${globalTheme.spacing.xxs};
    right: ${globalTheme.spacing.xxs};
  `};
  ${(props) => props.placement === 'middle' && css`
    top: calc(50% - ${globalTheme.spacing.sm} / 2);
    left: calc(50% - ${globalTheme.spacing.sm} / 2);
  `};
`;

export interface PlacementOptionProps {
  placement: OverlayPlacementName,
}

export const PlacementOption: FC<PlacementOptionProps> = ({ placement }) => (
  <Root>
    <Square placement={placement} />
  </Root>
);
